import { Injectable } from '@angular/core';
import { LoggerProvider, LoggerEvent } from '../logger/logger';
import { ScriptProvider } from '../script/script';
import { Platform } from 'ionic-angular';
import { APP_CONFIG } from '../../environment';

declare let window: any;
declare let APIGuardPlugin;
@Injectable()
export class APIGuardProvider {

  private apiGuardLoaded = false;
  private firstHeaders = true;

  constructor(private scriptProvider: ScriptProvider,
    private platform: Platform) {
  }

  async isInit() {
    await this.platform.ready();
    if (this.platform.is('cordova'))
      return await APIGuardPlugin.isInit();
  }

  async getRequestHeaders(url, body): Promise<any> {
    const first = this.firstHeaders;
    this.firstHeaders = false;

    if (first)
      LoggerProvider.info(this, 'Generate APIGuard headers');
    return new Promise<void>(async (resolve, reject) => {
      if (!this.apiGuardLoaded)
        this.apiGuardLoaded = !!(await this.isInit());
      const apiGuardState = this.apiGuardLoaded;
      if (this.platform.is('cordova')) {
        if (apiGuardState) {
          APIGuardPlugin.getRequestHeaders(url, body,
            (generatedHeaders) => {
              if (first)
                LoggerProvider.info(this.apiGuardLoaded, "APIGuardPlugin generated headers", generatedHeaders);
              resolve(generatedHeaders);
            },
            (error) => {
              if (first)
                LoggerProvider.error(this, LoggerEvent.ProviderException, "APIGuardPlugin error generating headers", error);
              resolve(null);
            }
          );
        } else {
          if (first)
            LoggerProvider.warning(this, LoggerEvent.ProviderException, 'APIGuardPlugin not available');
          resolve(null);
        }
      }
      else {
        // Browser
        resolve(null);
      }
    })
  }

  async parseResponseHeaders(headers: Record<string, string>): Promise<any> {
    if (!this.platform.is('cordova') || !headers)
      return null;
    return new Promise(async (resolve) => {
      APIGuardPlugin.parseResponseHeaders(
        headers,
        (result: string) => resolve(result),
        (error: string) => {
          LoggerProvider.warning(this, LoggerEvent.ProviderException, 'APIGuardPlugin error parsing response headers', error);
          resolve(null);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/http/api-guard.ts